import React, { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import styles from './styles.module.scss'
import CloseIcon from '@material-ui/icons/Close'
import { TextField, Select, MenuItem } from '@material-ui/core'
import { ErrorMessage } from 'components/'
import ModalWrapper from 'components/ModalWrapper'
import AsyncButton from 'utils/AsyncButton'
import { userEditorInitialValues } from 'utils/formik/initialValues'
import { userEditorValidationSchema } from 'utils/formik/validationSchema'
import {
  USER_EDIT_SUCCESS_MESSAGE,
  COGNITO_ERROR_MESSAGE,
} from 'const'
import { updateUser, FetchedUser } from 'api/users'
import { useHistory } from 'react-router-dom'
import UserDeleteConfirmModal from '../UserDeleteConfirmModal'

export interface Props {
  closeModal: () => void
  selectedUser?: FetchedUser | undefined
}

const UserEditorModal = ({ closeModal, selectedUser }: Props) => {
  const history = useHistory()
  const [isUserDeleteConfirmModalOpen, setIsUserDeleteConfirmModalOpen] = useState<boolean>(false)
  const [isUserEditorSubmitInProgress, setIsUserEditorSubmitInProgress] = useState<boolean>(false)
  const userId: string | undefined = selectedUser?.userId
  const userEditorFormik = useFormik({
    initialValues: userEditorInitialValues,
    validationSchema: userEditorValidationSchema,
    onSubmit: async (values) => {
      setIsUserEditorSubmitInProgress(true)
      await updateUser(userId, values)
        .then(() => {
          alert(USER_EDIT_SUCCESS_MESSAGE)
          history.go(0)
        })
        .catch((err) => {
          console.error(err)
          alert(COGNITO_ERROR_MESSAGE)
        })
      setIsUserEditorSubmitInProgress(false)
    },
  })
  useEffect(() => {
    userEditorFormik.setFieldValue('email', selectedUser?.cognitoEmail)
    userEditorFormik.setFieldValue('name', selectedUser?.userName)
    userEditorFormik.setFieldValue('groupBefore', selectedUser?.groupName)
    userEditorFormik.setFieldValue('groupAfter', selectedUser?.groupName)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div>
        <CloseIcon fontSize="large" className={styles.closeImg} onClick={closeModal} />
      </div>
      <div className={styles.modalBox}>
        <p className={styles.header}>ユーザー情報変更</p>
        <div className={styles.contentBox}>
          <div>
            <p>Eメールアドレス</p>
            <TextField
              fullWidth
              type="text"
              variant="outlined"
              disabled
              value={selectedUser?.cognitoEmail}
            />
          </div>
          <div>
            <p>氏名</p>
            <TextField
              fullWidth
              type="text"
              variant="outlined"
              {...userEditorFormik.getFieldProps('name')}
              value={userEditorFormik.values.name || ''}
              onChange={(event) => userEditorFormik.setFieldValue('name', event.target.value)}
              error={!!(userEditorFormik.touched.name && userEditorFormik.errors.name)}
            />
            <ErrorMessage
              touched={userEditorFormik.touched.name}
              error={userEditorFormik.errors.name}
            />
          </div>
          <div>
            <p>権限</p>
            <Select
              className={styles.select}
              id="group"
              value={userEditorFormik.values.groupAfter || userEditorFormik.values.groupBefore || ''}
              onChange={(event) => userEditorFormik.setFieldValue('groupAfter', event.target.value)}
            >
              <MenuItem value="supervisor">supervisor</MenuItem>
              <MenuItem value="advisor">advisor</MenuItem>
            </Select>
          </div>
          <div>
            <AsyncButton
              type="button"
              variant="contained"
              color="secondary"
              className={styles.deleteButton}
              onClick={() => {
                setIsUserDeleteConfirmModalOpen(true)
              }}
              loading={false}
            >
              削除
            </AsyncButton>
            <AsyncButton
              type="button"
              variant="contained"
              color="primary"
              className={styles.editButton}
              onClick={async () => {
                await userEditorFormik.validateForm()
                userEditorFormik.handleSubmit()
              }}
              loading={isUserEditorSubmitInProgress}
            >
              変更
            </AsyncButton>
          </div>
        </div>
      </div>
      <ModalWrapper
        open={isUserDeleteConfirmModalOpen}
        handleClose={() => setIsUserDeleteConfirmModalOpen(false)}
        scroll={true}
        content={
          <UserDeleteConfirmModal
            closeModal={() => setIsUserDeleteConfirmModalOpen(false)}
            selectedUser={selectedUser}
          />
        }
      />
    </>
  )
}
export default UserEditorModal
